import { captureMessage, Severity } from "@sentry/browser";
import { getEnv } from "helpers/env";

export { Severity };
export const reportToSentry = (message: string, severity: Severity = Severity.Log) => captureMessage(message, severity);

export const getAppVersion = getEnv("REACT_APP_SENTRY_RELEASE").split("@")[1];
